// useScrollSpy.js
import { useState, useEffect } from 'react';

export default function useScrollSpy(sectionIds = []) {
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const sections = sectionIds.map((id) => document.getElementById(id));
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        // Find the most visible section
        let maxVisibility = 0;
        let mostVisibleSection = null;

        entries.forEach((entry) => {
          const visibility = entry.intersectionRatio;
          if (visibility > maxVisibility) {
            maxVisibility = visibility;
            mostVisibleSection = entry.target.id;
          }
        });

        if (mostVisibleSection) {
          setActiveSection(mostVisibleSection);
        }
      },
      {
        root: null,
        rootMargin: '-70px 0px -30% 0px', // Adjusted to better detect sections, especially Use Cases
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] // More granular thresholds for better detection
      }
    );

    sections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, [sectionIds]);

  return activeSection;
}